import { render, staticRenderFns } from "./PendingBq.vue?vue&type=template&id=67b5f2f8"
import script from "./PendingBq.vue?vue&type=script&lang=js"
export * from "./PendingBq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports